import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as CreatorsGrade } from "../../Models/Reducers/GradeReducer";
import GradeScreen from "./GradeScreen";

const mapStateToProps = (state, props) => {
  return {
    gradeState: state.gradeState
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...CreatorsGrade
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GradeScreen);
